import { useEffect, useState } from 'react';
import { createRoute } from '@tanstack/react-router';

import { rootRoute } from '../routerBase';
import { FrameSkeleton } from '../../components/Skeleton/FrameSkeleton';
import { useTranslation } from '../../hooks/useTranslation';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
// Type-only import so the route chunk stays split — the runtime module is
// loaded via dynamic import() inside the route's effect (see below).
import type SalesTracking from '../../components/SalesTracking/index';

export const salesTrackingIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sales_tracking',
  component: function SalesTrackingIndexRoute() {
    const { t } = useTranslation();
    useDocumentTitle(t('common.page_titles.sales_tracking'));
    const [Component, setComponent] = useState<typeof SalesTracking | null>(null);
    useEffect(() => {
      import('../../components/SalesTracking/index').then((mod) => {
        setComponent(() => mod.default);
      });
    }, []);
    if (!Component) {
      return <FrameSkeleton />;
    }
    return <Component />;
  },
});
